export default __webpack_public_path__ + "static/media/117_mobile.ce0e365f.jpg";